import i18next from 'i18next';
import { ERROR_CATEGORY, ErrorLevel } from 'app/lib/constants';

export const Types = [
    {
        value: ERROR_CATEGORY.schema,
        label: i18next.t('components:ProblemsPanel.errorTypes.structural')
    },
    {
        value: ERROR_CATEGORY.dataQuality,
        label: i18next.t('components:ProblemsPanel.errorTypes.dataQuality')
    },
    {
        value: ERROR_CATEGORY.compilation,
        label: i18next.t('components:ProblemsPanel.errorTypes.compilation')
    }
];

export enum SeverityLevel {
    ALL = 'all',
    ERRORS = 'errors',
    WARNINGS = 'warnings'
}

export const ErrorLevelMap = {
    [ErrorLevel.ERROR]: SeverityLevel.ERRORS,
    [ErrorLevel.WARNING]: SeverityLevel.WARNINGS
};

export const initialFilterConfiguration = {
    types: [],
    nodes: [],
    severity: SeverityLevel.ALL
};

export const panelHeight = 0.75 * window.innerHeight;
export const panelWidth = 400;
